import React from "react";
import qs from "qs";
import moment from "moment";
import { getItem, setItem } from "../../util/util";

class RedirectToLive extends React.Component {
  componentDidMount() {
    const search = document.location.search;

    const querystring = search.substring(1);
    let user = qs.parse(querystring).user; //从url中取room
    // let userid = getItem("userid");
    // if (!userid || userid == "undefined") {
    //   const now = moment();
    //   userid = now.unix() * 1000 + now.millisecond();
    //   setItem("userid", userid);
    // }
    const url = `${window.liveHost}appid=${window.appid}&domain=${
      window.domain
    }&return=${window.return}&action=${window.action}&user=${user}&goto=${
      window.goto
    }`;
    console.log(url)
    window.location.href = url;
  }
  render() {
    return null;
  }
}

export default RedirectToLive;
